export const DELETE_IMAGE_FAILURE = 'DELETE_IMAGE_FAILURE';

export const deleteImageFailure = (payload: Error) => ({
    type: DELETE_IMAGE_FAILURE,
    payload,
    error: true,
});
